import { render, staticRenderFns } from "./UserProjects.vue?vue&type=template&id=69dd791f"
import script from "./UserProjects.vue?vue&type=script&lang=ts"
export * from "./UserProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports